import { Scrollbars } from "react-custom-scrollbars-2";

const CustomScrollBar = (props: any) => {
  const renderView = ({ style, ...props }: any) => {
    const viewStyle = {};
    return (
      <div className="box" style={{ ...style, ...viewStyle }} {...props} />
    );
  };

  const renderThumb = ({ style, ...props }: any) => {
    const thumbStyle = {
      backgroundColor: "#B79B6C",
      height: "12px",
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
  };

  const renderTrack = ({ style, ...props }: any) => {
    const trackStyle = {
      backgroundColor: "transparent",
      position: "absolute",
      width: "100%",
      height: "12px",
      left: 0,
      bottom: 0,
      zIndex: 1,
    };
    return (
      <div
        style={{ ...style, ...trackStyle }}
        {...props}
        className="custom-scroll-track"
      />
    );
  };

  return (
    <Scrollbars
      style={{ height: 340 }}
      autoHeight={false}
      renderView={renderView}
      renderThumbHorizontal={renderThumb}
      renderTrackHorizontal={renderTrack}
      {...props}
    />
  );
};

export default CustomScrollBar;
